// Browser Tracking Types and Interfaces

export enum DeviceType {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
  TABLET = "TABLET",
}

export interface BrowserFingerprintDTO {
  id?: number;
  browserFingerprintKey: number;
  deviceType?: DeviceType;
  os?: string;
  osVersion?: string;
  browserName?: string;
  browserVersion?: string;
  userAgent?: string;
  createTimestamp?: string;
  updateTimestamp?: string;
}

export interface BrowserSessionDTO {
  id?: number;
  sessionId: string;
  browserFingerprintKey: number;
  browserFingerprint?: BrowserFingerprintDTO;
  loginUserIds?: number[];
  deviceManufacturer?: string;
  deviceModel?: string;
  createTimestamp?: string;
  updateTimestamp?: string;
}

export interface CreateBrowserFingerprintRequest {
  browserFingerprintKey: number;
  deviceType?: DeviceType;
  os?: string;
  osVersion?: string;
  browserName?: string;
  browserVersion?: string;
  userAgent?: string;
}

export interface CreateBrowserSessionRequest {
  sessionId: string;
  browserFingerprintKey: number;
  loginUserIds?: number[];
  deviceManufacturer?: string;
  deviceModel?: string;
}

export interface UpdateBrowserSessionRequest {
  sessionId: string;
  browserFingerprintKey: number;
  loginUserIds?: number[];
  deviceManufacturer?: string;
  deviceModel?: string;
}

export interface BrowserInfo {
  deviceType: DeviceType;
  os: string;
  osVersion: string;
  browserName: string;
  browserVersion: string;
  userAgent: string;
  deviceManufacturer?: string;
  deviceModel?: string;
}
